import { Box } from "@mui/material";
import styled from "styled-components/macro";

export const CKEditorWrapper = styled(Box)`
  &.ck-content {
    background: black;
  }
`;
